import avatar from '@/assets/flo/avatar.png';
import CheckCategories from '@/components/CheckCategories';
import { ApplicationState } from '@/store';
import { getFavoriteListRequest } from '@/store/favorite/actions';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

const EditTopicsOfInterest: React.FC = () => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getFavoriteListRequest());
    }, [dispatch]);

    return (
        <>
            <div className="edit-interests-container">
                <div className="edit-header">
                    <span className="title">{strings.PROFILE_MENU.TOPICS_OF_INTEREST}</span>
                </div>

                <div className="bot-container">
                    <div className="image-bot-container">
                        <img className="image-flo" src={avatar} />
                    </div>

                    <div className="bot-text-container">
                        <span className="title">{strings.HELP_REFINE_RECOMMENDATIONS}</span>
                        <span className="description">{strings.HELP_REFINE_RECOMMENDATIONS_EXPLANATION}</span>
                    </div>
                </div>

                <CheckCategories saveOnSelect={false} />
            </div>
        </>
    );
};

export default EditTopicsOfInterest;
